import type { ScoreSetCompletionDto } from "@/modules/scores/scoreForms/gateway/scoreDto"
import type { ScoreSetCompletionFormikType } from "@/modules/scores/scoreForms/scoreFormikTypes"
import { ScoreType } from "@/modules/scores/scoreTypes"
import { convertScoreFromInput, convertScoreToInputValue } from "@/modules/scores/scoreUtils"
import type { HUUnit } from "@/modules/utils/unitType"

export class ScoreSetCompletionEntity {
  id: string | null
  scoreSetConfigurationId: string
  displayOrder: number
  timeCapExceeded: boolean | null
  score: number | null
  scoreAdditional: number | null
  scoreType: ScoreType
  feedback: string | null

  constructor(scoreSetCompletion: ScoreSetCompletionEntity) {
    this.id = scoreSetCompletion.id
    this.scoreSetConfigurationId = scoreSetCompletion.scoreSetConfigurationId
    this.displayOrder = scoreSetCompletion.displayOrder
    this.timeCapExceeded = scoreSetCompletion.timeCapExceeded
    this.score = scoreSetCompletion.score
    this.scoreAdditional = scoreSetCompletion.scoreAdditional
    this.scoreType = scoreSetCompletion.scoreType
    this.feedback = scoreSetCompletion.feedback
  }

  static fromDto(dto: ScoreSetCompletionDto): ScoreSetCompletionEntity {
    return new ScoreSetCompletionEntity({
      id: dto.id,
      scoreSetConfigurationId: dto.scoreSetConfigurationId,
      displayOrder: dto.displayOrder,
      timeCapExceeded: dto.timeCapExceeded,
      score: dto.score,
      scoreAdditional: dto.scoreAdditional,
      scoreType: dto.scoreType,
      feedback: dto.feedback,
    })
  }

  static fromEntityToFormik(entity: ScoreSetCompletionEntity, unit: HUUnit): ScoreSetCompletionFormikType {
    return {
      id: entity.id,
      scoreSetConfigurationId: entity.scoreSetConfigurationId,
      displayOrder: entity.displayOrder,
      timeCapExceeded: entity.timeCapExceeded,
      score: convertScoreToInputValue(entity.score, entity.scoreType, unit),
      scoreAdditional: entity.scoreAdditional,
      scoreType: entity.scoreType,
      feedback: entity.feedback,
    }
  }

  static fromFormikToInputDto(formik: ScoreSetCompletionFormikType, unit: HUUnit): ScoreSetCompletionDto {
    if (!formik.score) throw new Error("Score is required")
    return {
      id: formik.id,
      scoreSetConfigurationId: formik.scoreSetConfigurationId,
      displayOrder: formik.displayOrder,
      timeCapExceeded: formik.timeCapExceeded,
      score: convertScoreFromInput(formik.score, formik.scoreType, unit),
      scoreAdditional: formik.scoreAdditional,
      scoreType: formik.scoreType,
      feedback: formik.feedback,
    }
  }
}
